import { getEffectiveZoneArea } from 'features/libra/stepComponents/zoneAnalysis/niiStrategy'
import { ZoneParams } from 'features/libra/stepComponents/zoneAnalysis/zoneAnalysisApi'

import { PlanningStrategies } from './planningTypes'

export function getPlanningStrategy(
  zone: ZoneParams,
  strategies: PlanningStrategies
) {
  const strategyType =
    zone.nii_strategy?.strategy_type_override ??
    zone.nii_strategy?.strategy_type_calculated
  const strategyConfig = strategyType ? strategies[strategyType] : undefined
  return {
    strategyType,
    detailedDrawing: strategyConfig?.detailedDrawing ?? false,
    requirePlan: strategyConfig?.requirePlan ?? false,
    guidance: strategyConfig?.guidance,
    plannedCoveragePercent:
      strategyConfig?.plannedCoveragePercent ??
      zone.coverage_calculation?.required_coverage_percent,
  }
}

export function getRequiredInspectionArea(
  zone: ZoneParams,
  strategies: PlanningStrategies
): number | undefined {
  const { strategyType, plannedCoveragePercent } = getPlanningStrategy(
    zone,
    strategies
  )
  if (!strategyType) return undefined
  if (plannedCoveragePercent === 100) {
    const area = getEffectiveZoneArea(zone)
    if (area > 0) return area
    if (zone.coverage_calculation?.required_coverage_percent !== 100)
      return undefined
  }
  const area = zone.coverage_calculation?.required_coverage_area_sq_m
  return area !== undefined && area > 0 ? area : undefined
}
